import { Flex } from '@chakra-ui/react';
import { Logo } from '@morressier/alembic';
import {
  IBrandLayoutProps
} from 'src/contexts/BrandConfigProvider';
import { ClientBrand } from '../../routes/AuthRealmAccessControl/AuthRealmContext';

export const basicBrandLayout =
  (brandConfig: ClientBrand) =>
  ({ children }: IBrandLayoutProps) =>
    (
      <Flex width="100%" minHeight="100vh" gap={8}>
        <Flex width="100%" flexDirection="column" gap={8} alignItems="center">
          {/* --- Banner --- */}
          <Flex width="100%" height="320px">
            <Flex
              backgroundImage={brandConfig.footerUrl}
              backgroundSize="cover"
              backgroundPosition="center"
              backgroundRepeat="no-repeat"
              width="100%"
              height="100%"
            />
          </Flex>

          <Flex
            justifyContent="center"
            width="720px"
            flexDirection="column"
            gap="4"
          >
            <Flex width="240px">
              <Logo
                src={brandConfig.logoUrl}
                alt={`${brandConfig.name} logo`}
              />
            </Flex>
            {children}
          </Flex>
        </Flex>
      </Flex>
    );
